import { getEnvironment } from '@toloka-tb/common/utils/environment';
import { nanoid } from 'nanoid';

import { setAuthTokenHook } from '../utils';
import { sendTbApiRequest } from '../utils/sendTbApiRequest';

export type UploadFileResponse = string | { sasLink: string | null; storageFileName: string; downloadLink?: string };

const baseUrl = getEnvironment() === 'dev' ? 'https://prestable.api-ui.toloka-test.ai' : 'https://api-ui.toloka.ai';

export const uploadFile = async (file: File): Promise<UploadFileResponse> => {
    const annotationEditId = window.A9S_TASK_INFO?.annotationEditId;

    if (!annotationEditId) {
        if (window.TB_LAUNCHER_NAME === 'editor') {
            console.warn('Annotation Edit ID is missing');

            return new Promise<UploadFileResponse>((resolve) => {
                setTimeout(() => {
                    resolve({ sasLink: null, storageFileName: nanoid() });
                }, 500);
            });
        } else {
            throw new Error('Annotation Edit ID is missing');
        }
    }

    const formData = new FormData();

    formData.append('file', file, file.name);
    formData.append('annotation-edit-id', annotationEditId);

    return sendTbApiRequest<UploadFileResponse>({
        endpointName: `media-server.upload-file`,
        url: `${baseUrl}/api/v1/annotation-files/upload`,
        method: 'POST',
        body: formData,
        credentials: 'include',
        hooks: {
            beforeRequest: [setAuthTokenHook],
            afterResponse: [
                async (_request, _options, response) => {
                    const sasLink = response.headers.get('X-Download-Url');
                    const storageFileName = await response.text();

                    return new Response(JSON.stringify({ sasLink, storageFileName }), { status: 200 });
                }
            ]
        },
        apiChannelExtraOptions: { blob: file, annotationEditId }
    });
};
